import { Modal, Typography } from "antd";
import React from "react";

const DialogPrevEmployeeNotDone = ({ open }) => {
  return (
    <Modal
      title=""
      open={open}
      //   onCancel={() => close()}
      closable={false}
      footer={null}
      width={350}
      centered
    >
      <Typography style={{ fontWeight: "bold", color: "red", fontSize: 18 }}>
        Notice:
      </Typography>
      <Typography style={{ fontWeight: "bold", fontSize: 16 }}>
        Previous Cashier Doesn't Submit The Daily Cash Count! Please coordinate
        with the previos cashier or forward your concern to the team leader to
        fix this.
      </Typography>
    </Modal>
  );
};

export default DialogPrevEmployeeNotDone;
